/* Component-aware delivery, pickup and financing. Never uses parent-product stock. */
(function () {
  function aggregate(items, nodes) {
    if (!items.length || nodes.length !== items.length || nodes.some(n => !n)) return null;
    const pairs = items.map(item => ({item, node:nodes.find(n => n.id.split('/').pop() === String(item.id))}));
    if (pairs.some(({item,node}) => !node || !node.availableForSale || !Number.isFinite(node.quantityAvailable) || node.quantityAvailable < item.quantity)) return null;
    const local = n => n.available && n.quantityAvailable > 0 && !/day|d[ií]a|jour|giorn|tag|\d\s*-\s*\d/i.test(n.pickUpTime || '');
    const names = [...new Set(nodes.flatMap(n => n.storeAvailability.nodes.map(s => s.location.name)))];
    const stores = names.map(name => ({location:{name}, available:pairs.every(({item,node}) => node.storeAvailability.nodes.some(s => s.location.name === name && local(s) && s.quantityAvailable >= item.quantity)), pickUpTime:'', quantityAvailable:0}));
    return {id:'gid://shopify/ProductVariant/groupset', availableForSale:true, quantityAvailable:1, product:{metafield:null}, storeAvailability:{nodes:stores}};
  }
  if (typeof module !== 'undefined') module.exports = {aggregate};
  if (typeof window === 'undefined') return;
  window.VelodromGroupsetAggregate = aggregate; // Cart dates for configured groupset lines.

  customElements.whenDefined('shipping-time').then(() => {
    if (!customElements.get('groupset-shipping-time')) customElements.define('groupset-shipping-time', class extends customElements.get('shipping-time') {
      fetchVariantInfo() {} // The groupset adapter supplies the whole configuration.
      injectShippingProperty() {} // No parent-variant fulfillment properties.
    });
  });

  class Accelerators extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.owner = this.closest('groupset-configurator');
      this.delivery = this.querySelector('groupset-shipping-time');
      this.copy = JSON.parse(this.querySelector('[data-accelerator-copy]').textContent);
      this.abort = new AbortController();
      this.owner.addEventListener('groupset:change', e => this.update(e.detail), {signal:this.abort.signal});
      if (this.owner.result) this.update({result:this.owner.result, quote:this.owner.quote});
      this.timer = setInterval(() => { if (this.last) this.update(this.last); },60000);
    }
    disconnectedCallback() { this.abort?.abort(); this.request?.abort(); clearInterval(this.timer); this.ready=false; }
    finance(quote) {
      const widget = this.owner.querySelector('[data-financing]');
      if (!widget || !window.FinancingWidget) return;
      if (!Number.isInteger(quote) || quote < 3500 || this.owner.dataset.currency !== 'EUR') { widget.hidden=true; return; }
      const source = widget.cloneNode(true);
      source.dataset.priceCents = String(quote);
      source.dataset.mode = quote <= 200000 ? 'pay3' : 'financing';
      source.querySelector('.financing__lead').textContent = this.copy.financing;
      const pp = source.querySelector('[data-panel="paypal"]');
      pp.replaceChildren();
      const template = this.querySelector('[data-paypal-template]');
      if (template) {
        pp.append(template.content.cloneNode(true));
        pp.querySelector('[data-pp-message]')?.setAttribute('data-pp-amount',(quote/100).toFixed(2));
      }
      window.FinancingWidget.sync(widget,source);
    }
    async update(detail) {
      this.last = detail;
      this.finance(detail.quote);
      const seq = this.seq = (this.seq || 0) + 1;
      this.request?.abort(); this.request = new AbortController();
      this.delivery.hidden = true;
      this.owner.deliveryNode = null;
      if (!detail.result.complete) return;
      try {
        const query = 'query($ids:[ID!]!){nodes(ids:$ids){... on ProductVariant{id availableForSale quantityAvailable storeAvailability(first:20){nodes{available quantityAvailable pickUpTime location{name}}}}}}';
        const response = await fetch(this.dataset.endpoint,{method:'POST',signal:this.request.signal,headers:{'Content-Type':'application/json','X-Shopify-Storefront-Access-Token':this.dataset.token},body:JSON.stringify({query,variables:{ids:detail.result.items.map(i=>'gid://shopify/ProductVariant/'+i.id)}})});
        const data = await response.json();
        if (seq !== this.seq) return;
        const combined = response.ok && !data.errors ? aggregate(detail.result.items,data.data?.nodes || []) : null;
        this.owner.deliveryNode = combined; // Used for the cart line's Estimated Delivery.
        if (!combined) return;
        await customElements.whenDefined('groupset-shipping-time');
        if (seq !== this.seq || !this.isConnected) return;
        this.delivery.hidden=false;
        this.delivery.updateShippingText(combined,'groupset');
        this.delivery.classList.remove('is-loading');
      } catch (error) {
        if (seq === this.seq && error.name !== 'AbortError') {
          this.delivery.hidden=true;
        }
      }
    }
  }
  if (!customElements.get('groupset-accelerators')) customElements.define('groupset-accelerators',Accelerators);
})();
